import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import "./index.scss";

import { CYCLE_STATE, SALARY_CALCULATION_TYPE, SALARY_CALCULATION_TYPE_VALUES, SHIFT_TYPE } from "../../../utils/enums";
import { Avatar } from "../Avatar/Avatar";
import { getFullName, getTotalCourierEstimation } from "../../../services/userModel";
import VehicleIcon from "../VehicleIcon";
import { List } from "react-virtualized";
import classNames from "classnames";
import AutoSizer from "react-virtualized-auto-sizer";
import IconButton from "../IconButton";

class AssociatePopupGroup extends React.PureComponent {
  isCourierHasOrders = courier => {
    const { orders } = this.props;
    return !!orders.filter(order => order.groupId === courier.userId)?.length;
  };

  rowRenderer = ({ index, key, style }, checked) => {
    const {
      t,
      couriers,
      handleChecked,
      showSalaryType,
    } = this.props;

    const courier = couriers[index];

    const courierArrivalEstimation = getTotalCourierEstimation(courier);

    // couriers fresh on shift have a cycle without orders (and backup couriers no cycle at all)
    const {pickupOrders, deliveryOrders} = (courier.cycle?.orders || []).reduce((acc, order) => {
      if(order.type > 0) {
        return {
          ...acc,
          pickupOrders: acc.pickupOrders.concat(order),
        }
      }
      if(!order.type) {
        return {
          ...acc,
          deliveryOrders: acc.deliveryOrders.concat(order),
        }
      }
      return acc;
    }, {
      pickupOrders: [],
      deliveryOrders: [],
    });

    const lastDeliveryOrders = deliveryOrders.length > 0 ? deliveryOrders[deliveryOrders.length - 1] : null;
    const dropOffAddress = lastDeliveryOrders ? `${lastDeliveryOrders.address?.street || lastDeliveryOrders.street || ''}, ${lastDeliveryOrders.address?.city || lastDeliveryOrders.city || ''}` : '';

    return (
      <div key={courier.userId + key}
        style={style}
        className="courierGroupItem"
        onClick={e => handleChecked(courier.userId, e)}
      >
        <Avatar avatar={courier.avatarUrl} color={courier.color} />
        <div className="courierInfo">
          <span className="courierInfoTitle">
            <VehicleIcon value={courier.vehicleType} isActive={true} />&nbsp;&nbsp;
            {showSalaryType && courier?.cycle?.salaryCalculationMode === SALARY_CALCULATION_TYPE.Hourly && courier?.cycle && courier.cycle.shiftType !== SHIFT_TYPE.Backup && !this.isCourierHasOrders(courier) && courier.cycle && courier.cycle.state === CYCLE_STATE.started && (
              <span className="salaryCalculationType">{SALARY_CALCULATION_TYPE_VALUES()[courier?.cycle?.salaryCalculationMode]}</span>
            )}
            {getFullName(courier)}
          </span>
          {courier.cycle && courier.cycle.state === CYCLE_STATE.started && (
            <div className="courierInfoLabelGroup">
              <div className="ordersAndAddress">
                <div className="orderCounts">
                  {(pickupOrders.length > 0) && (
                    <span className="courierInfoLabelOrders">
                      {t('draft.pickups')}&nbsp;
                      {pickupOrders.length}
                    </span>
                  )}
                  {(deliveryOrders.length > 0) && (
                    <span className="courierInfoLabelOrders">
                      {t('draft.deliveries')}&nbsp;
                      {deliveryOrders.length}
                    </span>
                  )}
                </div>
                {dropOffAddress && (
                  <div className="orderAddress"><IconButton isIcon iconName={'flagIcon'} /> {dropOffAddress}</div>
                )}
              </div>
              <div className="courierInfoLaberStatusAndEstimation">
                <span className={classNames("courierInfoLabel", {
                  statusBackup: courier.cycle.shiftType === SHIFT_TYPE.Backup,
                  statusWaiting: courier.cycle.shiftType !== SHIFT_TYPE.Backup && !this.isCourierHasOrders(courier),
                  statusAwaiting: courier.cycle.shiftType !== SHIFT_TYPE.Backup && this.isCourierHasOrders(courier),
                })}>
                  {courier.cycle.shiftType === SHIFT_TYPE.Backup && t("dashboard.couriersbar.BACKUP_GROUP_LABEL")}
                  {courier.cycle.shiftType !== SHIFT_TYPE.Backup && (this.isCourierHasOrders(courier) ? t("dialogs.couriers.AWAITING_APPROVAL_LABEL") : t("dialogs.couriers.WAITING_FOR_ORDERS"))}
                </span>
                {courierArrivalEstimation && (
                  <span className="courierInfoLabelEstimation">
                    <IconButton isIcon iconName={'flagIcon'} /> {courierArrivalEstimation}
                  </span>
                )}
              </div>
            </div>
          )}
          {courier.cycle && courier.cycle.state === CYCLE_STATE.approved && (
            <div className="courierInfoLabelGroup">
              <div className="ordersAndAddress">
                <div className="orderCounts">
                  {(pickupOrders.length > 0) && (
                    <span className="courierInfoLabelOrders">
                      {t('draft.pickups')}&nbsp;
                      {pickupOrders.length}
                    </span>
                  )}
                  {(deliveryOrders.length > 0) && (
                    <span className="courierInfoLabelOrders">
                      {t('draft.deliveries')}&nbsp;
                      {deliveryOrders.length}
                    </span>
                  )}
                </div>
                {dropOffAddress && (
                  <div className="orderAddress"><IconButton isIcon iconName={'flagIcon'} /> {dropOffAddress}</div>
                )}
              </div>
              <div className="courierInfoLaberStatusAndEstimation">
                <span className="courierInfoLabel statusReady">
                  {t("dialogs.couriers.READY_LABEL")}
                </span>
                {courierArrivalEstimation && (
                  <span className="courierInfoLabelEstimation">
                    <IconButton isIcon iconName={'flagIcon'} /> {courierArrivalEstimation}
                  </span>
                )}
              </div>
            </div>
          )}
          {courier.cycle && courier.cycle.state === CYCLE_STATE.deliveryStart && (
            <div className="courierInfoLabelGroup">
              <div className="ordersAndAddress">
                <div className="orderCounts">
                  {(pickupOrders.length > 0) && (
                    <span className="courierInfoLabelOrders">
                      {t('draft.pickups')}&nbsp;
                      {pickupOrders.length}
                    </span>
                  )}
                  {(deliveryOrders.length > 0) && (
                    <span className="courierInfoLabelOrders">
                      {t('draft.deliveries')}&nbsp;
                      {deliveryOrders.length}
                    </span>
                  )}
                </div>
                {dropOffAddress && (
                  <div className="orderAddress"><IconButton isIcon iconName={'flagIcon'} /> {dropOffAddress}</div>
                )}
              </div>
              <div className="courierInfoLaberStatusAndEstimation">
                <span className="courierInfoLabel statusOnRoute">
                  {t("dialogs.couriers.ON_ROUTE_LABEL")}
                </span>
                {courierArrivalEstimation && (
                  <span className="courierInfoLabelEstimation">
                    <IconButton isIcon iconName={'flagIcon'} /> {courierArrivalEstimation}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="courierCheck">
          <input
            type="checkbox"
            id={`checkbox-${courier.userId}`}
            name="check"
            checked={checked === courier.userId}
            onChange={e => handleChecked(courier.userId, e)}
          />
          <label htmlFor={`checkbox-${courier.userId}`} />
        </div>
      </div>
    );
  };

  render() {
    const {
      couriers,
      title,
      emptyTitleText,
      maxHeight,
      checked
    } = this.props;
    const makeHeight = couriers?.length * 75 > window.innerHeight ? window.innerHeight : couriers.length * 75;

    return (
      <div className="courierGroupContainer">
        <div className="headerGroup">
          <span>{title ? title : ""}</span>
        </div>
        <div style={{ height: maxHeight ? '100%' : makeHeight }}>
          {!!couriers.length && (<AutoSizer >
            {({ height, width }) => {
              return <List
                className={classNames("listContent")}
                width={width}
                height={height}
                rowHeight={75}
                rowRenderer={(data) => this.rowRenderer(data, checked)}
                rowCount={couriers.length}
                overscanRowCount={1}
              />
            }}
          </AutoSizer>)}
        </div>

        {(!couriers || !couriers.length) &&
          emptyTitleText && (
            <div className="containerEmpty">
              <span className="empty">{emptyTitleText}</span>
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  orders: state.order.data.orders || []
});

export default connect(mapStateToProps)(withTranslation()(AssociatePopupGroup));
